import { Table, Typography,Row,Divider,Button,Space,Modal,message} from "antd";
import { useLocation } from "react-router-dom";
import AcademicUnitService from "../../../services/AcademicUnitService";
import AcademicUnitFormModal from "../Form/AcademicUnitForm";
import { useEffect, useState } from "react";
import {EditOutlined,DeleteOutlined} from '@ant-design/icons';
import { Link } from "react-router-dom";

const {Text,Title}= Typography;

export default function AcademicUnitTable() {
    const location=useLocation()
    const campus=location.state?.campus;
    const [listAcademicUnits,setListAcademicUnits]=useState([])
    const [ShowDeleteModal,setShowDeleteModal]=useState(false);
    const [academicUnitTarget,setAcademicUnitTarget]=useState({});
    const [OptionModal,setOptionModal]=useState(false);
    const [ShowCreate,setShowCreate]=useState(false);
    const [IsUpdated,setIsUpdated]=useState(false);
    const [loadingTable,setLoadingTable]=useState(true);

    const getAcademicUnitsOfCampus=()=>{
        AcademicUnitService.getListAcademitUnitByCampus(campus.id)
        .then((listAU)=>{
            console.log(listAU)
            setListAcademicUnits(listAU?.data?.response)
            setIsUpdated(false)
            setLoadingTable(false)
        })

    }
    const deleteAcademicUnitById=()=>{
        try {
            AcademicUnitService.deleteAcademicUnit(academicUnitTarget.id).then((res)=>{
                if(res.data?.success){
                    message.success('Se elimino correctamente la unidad academica',3);
                    setIsUpdated(true);
                    setShowDeleteModal(false);
                  }
            })
        } catch (error) {
            return error
        }
    }
    const handleClickDelete=(record)=>{
        console.log(record)
        setShowDeleteModal(true);
        setAcademicUnitTarget(record)
    }
    const updateCampusModal=(record)=>{
        setShowCreate(true)
        setOptionModal(false)
        console.log("1 record",record)
        setAcademicUnitTarget(record)
        console.log("2 CampusTarget ",academicUnitTarget)
    }
    const ShowCreateModal=()=>{
        setShowCreate(true)
        setOptionModal(true)
    }
    const hideCreateModal=(res)=>{
        setShowCreate(res);
    }
    const updatedTable=(response)=>{
        console.log("updatedTable",response)
        setIsUpdated(response);
    }
    const columns=[{
        title: "Nombre",
        dataIndex:"name",
        key:"name",
        render:(text)=><Text  style={ {
            width: "100%" ,
          }
    }
    ellipsis={{
            tooltip: {text},
          }
    }>{text}</Text>
    },{
        title:"Codigo",
        dataIndex:"code",
        key:"code"
    },{
        title:"Estado",
        dataIndex:"status",
        key:"status",
        render:(_,record)=> record.status? "activo":"inactivo"
    },{
        title:'Opciones',
        key:"optionsCampus",
        dataIndex:"",
        render:(_, record) => (
            <Space size="large" align='center'>
                <Link style={{display:"flex", flexDirection:"column"}} to={{pathname:"/campus/academicunit/"+record.id+"/view/",state:{academicUnit:record}}} >
                <EditOutlined> 
                </EditOutlined>
                <Text>Ver la informacion</Text>
                </Link>
                <Link style={{display:"flex", flexDirection:"column"}} onClick={()=>(updateCampusModal(record))}>
                <EditOutlined> 
                </EditOutlined>
                <Text>Editar</Text>
                </Link>
              <Link style={{display:"flex", flexDirection:"column"}} onClick={()=>handleClickDelete(record)}>
                <DeleteOutlined >
                </DeleteOutlined>
                <Text>Eliminar</Text>
              </Link>
            </Space>)
    }];

    useEffect(()=>{
        getAcademicUnitsOfCampus(campus.id);
    },[IsUpdated])
    return(
    <>
    <Row align="center">
        <Title level={2}>{campus.name}</Title>
        <Divider></Divider>
    </Row>
    <Row align="end">
        <Button 
        onClick={ShowCreateModal} 
        type="primary"
        style={{
            marginRight:"4%",
            marginBottom: 16,
            float: "right",
          }}
        >
            Añadir Unidad Academica
            </Button>
        <Divider></Divider>
    </Row>
    <Table 
    loading={loadingTable}
    style={{ marginLeft: "50px", marginRight: "50px", borderRadius:"3%"}}
        key={"id"}
        columns={columns}
        dataSource={listAcademicUnits}
    >
    </Table>
    <AcademicUnitFormModal
    AcademicUnitTarget={academicUnitTarget}
    ShowCreateModal={ShowCreateModal}
    visible={ShowCreate}
    Option={OptionModal}
    hideCreateModal={hideCreateModal}
    updatedTable={updatedTable}
    CampusId={campus.id}
    >

    </AcademicUnitFormModal>
        <Modal 
        title={`Eliminar la unidad academica '${academicUnitTarget.name}'`}
        open={ShowDeleteModal}
        onOk={deleteAcademicUnitById}
        onCancel={()=>setShowDeleteModal(false)}>
        </Modal>
    </>
    )
}